export default __webpack_public_path__ + "static/media/luna.c57c688a.svg";